import {
  RecurringServicesContractBurndownDto,
  UsageBalanceData,
} from "./canonical";
import { ExpertSupportTierValues } from "./constants";

/**
 * Maps a RecurringServicesContractBurndownDto to the UsageBalanceData shape
 * consumed by ServiceContractDetailsContainer.
 */
export function mapBurndownToUsageBalance(
  burndown: RecurringServicesContractBurndownDto | null | undefined,
): Omit<UsageBalanceData, "isLoading" | "error"> {
  if (!burndown) {
    return {
      usage: {},
      balance: {},
      balanceLabel: "Balance",
    };
  }

  const {
    expertSupportTier,
    totalPurchased = 0,
    totalPurchasedBilled = 0,
    totalPurchasedUnbilled = 0,
    currentBalance = 0,
    proactiveDollarsUsed = 0,
    totalUsed = 0,
  } = burndown;

  const usage: Record<string, number> = expertSupportTier === ExpertSupportTierValues.Proactive
    ? { "Total Dollars Used": totalUsed, "Proactive Dollars Used": proactiveDollarsUsed }
    : { "Total Dollars Used": totalUsed };
  
  return {
    usage,
    balance: {
      "Total Amount": totalPurchased,
      "Billed": totalPurchasedBilled,
      "Unbilled": totalPurchasedUnbilled,
      "Current Balance": currentBalance,
    },
    balanceLabel: "Balance",
  };
}

